<template>
  <div class="news-list">
        <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>查詢</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form>
            <v-row align="center">
              <v-col cols="12" md="3">
                <DateRange label="開始時間 (起)" v-model="searchForm.startStartOn" />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange label="開始時間 (迄)" v-model="searchForm.endStartOn" />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange label="結束時間 (起)" v-model="searchForm.startEndOn" />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange label="結束時間 (迄)" v-model="searchForm.endEndOn" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field label="標題" v-model="searchForm.q"></v-text-field>
              </v-col>
              <v-col cols="12" md="9" align="right">
                <v-btn class="ma-2" :loading="loading" @click="handleSerach"
                  >查詢</v-btn
                >
                <v-btn class="ma-2" @click="handleClear">清除</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
      <v-row style="margin-top:5px;">
        <v-col align="right">
          <v-icon @click="handleCreate">mdi-plus</v-icon>
        </v-col>
      </v-row>
    <v-row class="" style="margin-top:8px;">
      <v-col v-for="item in event" :key="item.id" cols="12" md="3">
        <v-card>
          <v-img :src="item.pic" height="200px"></v-img>
          <v-card-subtitle class="pb-0 pt-0">
            {{ item.startTime | date }}
          </v-card-subtitle>
          <v-card-title>
            {{ item.title }}
          </v-card-title>
          <v-card-text class="text--primary">
            <div class="news-list__content">
              {{ item.description }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn icon @click="handleEdit(item.id)"
              ><v-icon>mdi-lead-pencil</v-icon></v-btn
            >
            <v-btn icon @click="handleDelete(item.id)"
              ><v-icon>mdi-window-close</v-icon></v-btn
            >
            <v-btn text @click="handleWatchReport(item.url)">連結</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-pagination v-if="totalCount > 0"
        :value="page.pageNo"
        :length="pageCount"
        :total-visible="8"
        @input="updatePage"
    ></v-pagination>
  </div>
</template>

<script>
import api from '@/api';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';
import urlParameter from '@/utils/urlParameter';
import Swal from 'sweetalert2';

// const defaultPage = {
//   pageSize: 10,
//   pageNo: 1,
// };

export default {
  components: {
    DateRange,
  },
  data() {
    return {
      panel: 0,
      loading: false,
      deleteId: 0,
      searchForm: {
        startStartOn: this.$route.query.startStartOn
          ? this.$route.query.startStartOn
          : undefined,
        endStartOn: this.$route.query.endStartOn ? this.$route.query.endStartOn : undefined,
        startEndOn: this.$route.query.startEndOn
          ? this.$route.query.startEndOn
          : undefined,
        endEndOn: this.$route.query.endEndOn ? this.$route.query.endEndOn : undefined,
        q: this.$route.query.q ? this.$route.query.q : undefined,
      },
      event: [],
      page: {
        pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 8,
        pageNo: this.$route.query.pageNo ? this.$route.query.pageNo : 1,
      },
      totalCount: 0,
    };
  },
  filters: {
    date(value) {
      return moment(value).format('YYYY-MM-DD');
    },
  },
  created() {
    this.getEventList();
  },
  computed: {
    pageCount() {
      return Math.ceil((this.totalCount || 0) / (this.pageSize || 8));
    },
  },
  methods: {
    async getEventList() {
      const params = {
        ...this.removeEmptyValue(this.page),
        ...this.removeEmptyValue(this.searchForm),
      };
      const result = await api.event.eventList(params);
      const { totalCount = 0, data = [] } = result.data || {};
      this.totalCount = totalCount;
      this.event = data || [];
    },

    async query() {
      const query = { ...this.searchForm, pageNo: this.page.pageNo };
      if (urlParameter.isQueryChanged(this.$route, query)) {
        await this.$router.replace({ query });
      }
      this.getEventList();
    },

    handleSerach() {
      this.loading = true;
      this.page.pageNo = 1;
      this.query();
      this.loading = false;
    },

    updatePage(page) {
      this.page.pageNo = page;
      this.query();
    },

    removeEmptyValue(object) {
      const newObj = {};
      Object.keys(object).forEach((key) => {
        const value = object[key];
        const nullOrEmpty = value === '' || value === undefined || value === null;
        if (!nullOrEmpty) {
          newObj[key] = object[key];
        }
      });
      return newObj;
    },
    handleClear() {
      this.searchForm = {
        startStartOn: undefined,
        endStartOn: undefined,
        startEndOn: undefined,
        endEndOn: undefined,
        q: undefined,
      };
      this.page.pageNo = 1;
      this.query();
    },
    async handleDelete(id) {
      await Swal.fire(
        {
          title: '您確定要刪除嗎?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const { status } = await api.event.delete(id);
          if (status === 1) {
            await Swal.fire({ icon: 'success', title: '刪除成功' });
            this.getEventList();
          } else {
            await Swal.fire({ icon: 'warning', title: '刪除失敗，請聯繫系統管理員。' });
          }
        }
      });
    },
    handleEdit(eventId) {
      this.$router.push({
        name: 'event-edit',
        params: { eventId },
        query: { ...this.page, ...this.searchForm },
      });
    },
    handleCreate() {
      this.$router.push({
        name: 'event-create',
        query: { ...this.page, ...this.searchForm },
      });
    },
    handleWatchReport(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.news-list {
  &__content {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &__image {
    width: 32px;
  }
}
</style>
